const BillDetails = () => {
  return <p>Tarifa de Fatura</p>
}

export default BillDetails
